import BaseApi from './baseApi';
import INoticeOfLoss from '../models/INoticeOfLoss';
import IAuthentication from '../models/IAuthentication';
export default class InboundsNoticeOfLossApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "NoticeOfLoss");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetInboundsNoticeOfLoss(inboundDeliveryNotesId : string) : Promise<INoticeOfLoss[]> {
        let json : string = this.getJsonRead(inboundDeliveryNotesId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundsNoticeOfLoss: INoticeOfLoss[] = [];
            inboundsNoticeOfLoss = response.data as INoticeOfLoss[];
            return inboundsNoticeOfLoss;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveInboundsNoticeOfLoss(InboundsNoticeOfLoss: INoticeOfLoss) : Promise<string> {
        const json = this.getJsonSave(InboundsNoticeOfLoss);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateInboundsNoticeOfLoss(inboundsNoticeOfLoss: INoticeOfLoss) : Promise<boolean> {
        const json = this.getJsonUpdate(inboundsNoticeOfLoss);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteInboundsNoticeOfLoss(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsNoticeOfLoss",
            "conditions": [{
                "Item1": "InboundsNoticeOfLoss",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(noticeOfLoss: INoticeOfLoss) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idInboundDeliveryNote",
                "Item2": noticeOfLoss.idDeliveryNote
            }, {
                "Item1": "idWarehouse",
                "Item2": noticeOfLoss.idWarehouse
            }, {
                "Item1": "date",
                "Item2": noticeOfLoss.date
            }, {
                "Item1": "description",
                "Item2": noticeOfLoss.description
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "InboundsNoticeOfLoss"
        };
        return json;
    }

    private getJsonUpdate(inboundsNoticeOfLoss: INoticeOfLoss) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idInboundDeliveryNote",
                "Item2": inboundsNoticeOfLoss.idDeliveryNote
            }, {
                "Item1": "idWarehouse",
                "Item2": inboundsNoticeOfLoss.idWarehouse
            }, {
                "Item1": "date",
                "Item2": inboundsNoticeOfLoss.date
            }, {
                "Item1": "description",
                "Item2": inboundsNoticeOfLoss.description
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "InboundsNoticeOfLoss",
            "keyvalue": inboundsNoticeOfLoss.id
        };
        return json;
    }

    private getJsonRead(inboundDeliveryNotesId : string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsNoticeOfLoss",
                "Item2": "id"
            }, {
                "Item1": "InboundsNoticeOfLoss",
                "Item2": "idInboundDeliveryNote as idDeliveryNote"
            }, {
                "Item1": "InboundsNoticeOfLoss",
                "Item2": "idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "InboundsNoticeOfLoss",
                "Item2": "date"
            }, {
                "Item1": "InboundsNoticeOfLoss",
                "Item2": "description"
            }],
            "tables": [{
                "Item1": "InboundsNoticeOfLoss"
            }, {
                "Item1": "Warehouses"
            }],
            "joins": [{
                "Item1": "InboundsNoticeOfLoss",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsNoticeOfLoss",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsNoticeOfLoss",
                "Item2": "idInboundDeliveryNote",
                "Item3": "=",
                "Item4": inboundDeliveryNotesId
            }]
        };
        return json;
    }
}
